// @ts-strict-ignore
import isNil from 'lodash/isNil';

import {SharableEntityType} from 'common/report/util/saved-entities/types';
import {EventDefinition, PropertyDefinition} from 'apps/lexicon/src/models';
import {LexiconDefinition} from 'apps/lexicon/src/types';
import {ProjectFeatureFlag} from 'common/report/constants';
import {Metric} from 'app_api/projects/metrics/types';
import {BehaviorEntity as Behavior} from 'app_api/projects/behaviors/types';
import {isDataVolumeMonitoringEnabled} from 'common/report/util/feature-sampling';

export const alwaysTrue = () => true;

export function commaize(options: Set<string>): string {
  const optionsArr = Array.from(options);
  if (optionsArr.length === 1) {
    return optionsArr[0];
  }
  const last = optionsArr.pop();
  return optionsArr.join(`, `) + ` or ` + last;
}

export function appendNewLine(text: string) {
  if (text.length > 0) {
    return text + `\n`;
  }
  return text;
}

export function isEventDefinition(
  definition: LexiconDefinition,
  type?: SharableEntityType,
): definition is EventDefinition {
  return definition && (definition[`customEvent`] || type === SharableEntityType.CustomEvent);
}

export function isPropertyDefinition(
  definition: LexiconDefinition,
  type?: SharableEntityType,
): definition is PropertyDefinition {
  return definition && (definition[`customPropertyId`] || type === SharableEntityType.CustomProperty);
}

/**
 * Transforms metrics / behaviors into an object with each metric / behavior ID as key.
 */
export function getIndexedResources<T extends Metric | Behavior>(ctx: {getAllValues: () => T[]}): {[id: string]: T} {
  return Object.fromEntries(
    ctx
      .getAllValues()
      // filter out deleted values
      .filter((value) => !isNil(value))
      .map((value) => [value.id, value]),
  );
}

export function isDataVolumeMonitoringV2Enabled(currentProjectStore) {
  return (
    currentProjectStore?.value &&
    isDataVolumeMonitoringEnabled(currentProjectStore?.value) &&
    currentProjectStore.value.hasFeatureFlag(ProjectFeatureFlag.DataVolumeMonitoringV2)
  );
}

export const QUERY_METADATA_TOOLTIP = `Earliest query information is only captured after 01/01/2021.`;

export const FIRST_TRACKED_EARLIEST_DATE = `2021-01-01`;
